/**
 * Tenant API - Access tenant information and configuration
 * @module TenantAPI
 */

export class TenantAPI {
  constructor() {
    this.cache = null;
  }

  /**
   * Get current tenant information
   * @returns {Promise<object>} Tenant data
   * @example
   * const tenant = await WavelengthHub.tenant.current();
   * console.log(tenant.name); // "Ring Of Time Tabletop RPG"
   */
  async current() {
    if (this.cache) {
      return this.cache;
    }

    try {
      const response = await fetch('/api/tenant/current', {
        credentials: 'include'
      });
      
      if (!response.ok) {
        throw new Error(`Failed to fetch tenant: ${response.status}`);
      }
      
      this.cache = await response.json();
      return this.cache;
    } catch (error) {
      console.error('[TenantAPI] Error fetching tenant:', error);
      throw error;
    }
  }

  /**
   * Get tenant settings
   * @returns {Promise<object>} Tenant settings
   */
  async settings() {
    try {
      const response = await fetch('/api/tenant/settings', {
        credentials: 'include'
      });
      
      if (!response.ok) {
        return {};
      }
      
      return await response.json();
    } catch (error) {
      console.error('[TenantAPI] Error fetching settings:', error);
      return {};
    }
  }

  /**
   * Clear tenant cache
   */
  clearCache() {
    this.cache = null;
  }
}
